/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Count_ChangedInputs */

const en_us2_draft_count_changed = /** @type {(inputs: Draft_Count_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 adjustment`);
	return /** @type {LocalizedString} */ (`${i?.count} adjustments`)
	
};

const pt_br2_draft_count_changed = /** @type {(inputs: Draft_Count_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ajuste`);
	return /** @type {LocalizedString} */ (`${i?.count} ajustes`)
	
};

const es_419_draft_count_changed = /** @type {(inputs: Draft_Count_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ajuste`);
	return /** @type {LocalizedString} */ (`${i?.count} ajustes`)
	
};

const pt_pt2_draft_count_changed = /** @type {(inputs: Draft_Count_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ajuste`);
	return /** @type {LocalizedString} */ (`${i?.count} ajustes`)
	
};

const fr_fr2_draft_count_changed = /** @type {(inputs: Draft_Count_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ajustement`);
	return /** @type {LocalizedString} */ (`${i?.count} ajustements`)
	
};

const de_de2_draft_count_changed = /** @type {(inputs: Draft_Count_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Anpassung`);
	return /** @type {LocalizedString} */ (`${i?.count} Anpassungen`)
	
};

const it_it2_draft_count_changed = /** @type {(inputs: Draft_Count_ChangedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ritocco`);
	return /** @type {LocalizedString} */ (`${i?.count} ritocchi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 adjustment" |
* | * | "{count} adjustments" |
*
* @param {Draft_Count_ChangedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_count_changed = /** @type {((inputs: Draft_Count_ChangedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Count_ChangedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_count_changed(inputs)
	if (locale === "es-419") return es_419_draft_count_changed(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_count_changed(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_count_changed(inputs)
	if (locale === "de-DE") return de_de2_draft_count_changed(inputs)
	if (locale === "it-IT") return it_it2_draft_count_changed(inputs)
	return en_us2_draft_count_changed(inputs)
});
export { draft_count_changed as "draft.count_changed" }